export default __webpack_public_path__ + "static/media/tour-access-alarm-off.093805af.svg";